// extracted by mini-css-extract-plugin
export default {"root":"tVir9C","overlay":"ZTgfG4","isMenuOpen":"meddft","showBackgroundOverlay":"Ujf5u0","shouldScroll":"XTKAK7","scrollContent":"IKAmsN"};